<template>
  <div>
    <b-row vs-justify="center">
      <b-col cols="12">
        <b-card class="mb-4">
          <b-card-text>
            <h5 class="card-title">Arrows & Direction Icons</h5>
            <b-row class="icons">
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-arrow-up"></em> ti-arrow-up
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-arrow-right"></em> ti-arrow-right
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-arrow-left"></em> ti-arrow-left
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-arrow-down"></em> ti-arrow-down
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-arrows-vertical"></em> ti-arrows-vertical
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-arrows-horizontal"></em> ti-arrows-horizontal
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-angle-up"></em> ti-angle-up
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-angle-right"></em> ti-angle-right
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-angle-left"></em> ti-angle-left
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-angle-down"></em> ti-angle-down
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-angle-double-up"></em> ti-angle-double-up
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-angle-double-right"></em> ti-angle-double-right
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-angle-double-left"></em> ti-angle-double-left
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-angle-double-down"></em> ti-angle-double-down
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-move"></em> ti-move
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-fullscreen"></em> ti-fullscreen
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-arrow-top-right"></em> ti-arrow-top-right
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-arrow-top-left"></em> ti-arrow-top-left
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-arrow-circle-up"></em> ti-arrow-circle-up
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-arrow-circle-right"></em> ti-arrow-circle-right
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-arrow-circle-left"></em> ti-arrow-circle-left
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-arrow-circle-down"></em> ti-arrow-circle-down
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-arrows-corner"></em> ti-arrows-corner
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-split-v"></em> ti-split-v
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-split-v-alt"></em> ti-split-v-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-split-h"></em> ti-split-h
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-hand-point-up"></em> ti-hand-point-up
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-hand-point-right"></em> ti-hand-point-right
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-hand-point-left"></em> ti-hand-point-left
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-hand-point-down"></em> ti-hand-point-down
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-back-right"></em> ti-back-right
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-back-left"></em> ti-back-left
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-exchange-vertical"></em> ti-exchange-vertical
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>
        <b-card class="mb-4">
          <b-card-text>
            <h5 class="card-title">Web App Icons</h5>
            <b-row class="icons">
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-wand"></em> ti-wand
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-save"></em> ti-save
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-save-alt"></em> ti-save-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-direction"></em> ti-direction
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-direction-alt"></em> ti-direction-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-user"></em> ti-user
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-link"></em> ti-link
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-unlink"></em> ti-unlink
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-trash"></em> ti-trash
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-target"></em> ti-target
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-tag"></em> ti-tag
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-desktop"></em> ti-desktop
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-tablet"></em> ti-tablet
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-mobile"></em> ti-mobile
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-email"></em> ti-email
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-star"></em> ti-star
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-spray"></em> ti-spray
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-signal"></em> ti-signal
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-shopping-cart"></em> ti-shopping-cart
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-shopping-cart-full"></em> ti-shopping-cart-full
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-settings"></em> ti-settings
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-search"></em> ti-search
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-zoom-in"></em> ti-zoom-in
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-zoom-out"></em> ti-zoom-out
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-cut"></em> ti-cut
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-ruler"></em> ti-ruler
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-ruler-alt-2"></em> ti-ruler-alt-2
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-ruler-pencil"></em> ti-ruler-pencil
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-ruler-alt"></em> ti-ruler-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-bookmark"></em> ti-bookmark
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-bookmark-alt"></em> ti-bookmark-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-reload"></em> ti-reload
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-plus"></em> ti-plus
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-minus"></em> ti-minus
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-close"></em> ti-close
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-pin"></em> ti-pin
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-pencil"></em> ti-pencil
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-pencil-alt"></em> ti-pencil-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-paint-roller"></em> ti-paint-roller
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-paint-bucket"></em> ti-paint-bucket
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-na"></em> ti-na
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-medall"></em> ti-medall
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-medall-alt"></em> ti-medall-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-marker"></em> ti-marker
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-marker-alt"></em> ti-marker-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-lock"></em> ti-lock
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-unlock"></em> ti-unlock
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-location-arrow"></em> ti-location-arrow
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout"></em> ti-layout
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layers"></em> ti-layers
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layers-alt"></em> ti-layers-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-key"></em> ti-key
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-image"></em> ti-image
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-heart"></em> ti-heart
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-heart-broken"></em> ti-heart-broken
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-hand-stop"></em> ti-hand-stop
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-hand-open"></em> ti-hand-open
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-hand-drag"></em> ti-hand-drag
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-flag"></em> ti-flag
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-flag-alt"></em> ti-flag-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-flag-alt-2"></em> ti-flag-alt-2
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-eye"></em> ti-eye
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-import"></em> ti-import
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-export"></em> ti-export
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-cup"></em> ti-cup
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-crown"></em> ti-crown
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-comments"></em> ti-comments
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-comment"></em> ti-comment
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-comment-alt"></em> ti-comment-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-thought"></em> ti-thought
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-clip"></em> ti-clip
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-check"></em> ti-check
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-check-box"></em> ti-check-box
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-camera"></em> ti-camera
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-announcement"></em> ti-announcement
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-brush"></em> ti-brush
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-brush-alt"></em> ti-brush-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-palette"></em> ti-palette
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-briefcase"></em> ti-briefcase
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-bolt"></em> ti-bolt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-bolt-alt"></em> ti-bolt-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-blackboard"></em> ti-blackboard
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-bag"></em> ti-bag
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-world"></em> ti-world
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-wheelchair"></em> ti-wheelchair
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-car"></em> ti-car
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-truck"></em> ti-truck
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-timer"></em> ti-timer
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-ticket"></em> ti-ticket
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-thumb-up"></em> ti-thumb-up
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-thumb-down"></em> ti-thumb-down
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-stats-up"></em> ti-stats-up
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-stats-down"></em> ti-stats-down
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-shine"></em> ti-shine
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-shift-right"></em> ti-shift-right
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-shift-left"></em> ti-shift-left
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-shift-right-alt"></em> ti-shift-right-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-shift-left-alt"></em> ti-shift-left-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-shield"></em> ti-shield
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-notepad"></em> ti-notepad
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-server"></em> ti-server
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-pulse"></em> ti-pulse
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-printer"></em> ti-printer
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-power-off"></em> ti-power-off
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-plug"></em> ti-plug
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-pie-chart"></em> ti-pie-chart
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-panel"></em> ti-panel
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-package"></em> ti-package
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-music"></em> ti-music
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-music-alt"></em> ti-music-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-mouse"></em> ti-mouse
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-mouse-alt"></em> ti-mouse-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-money"></em> ti-money
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-microphone"></em> ti-microphone
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-menu"></em> ti-menu
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-menu-alt"></em> ti-menu-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-map"></em> ti-map
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-map-alt"></em> ti-map-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-location-pin"></em> ti-location-pin
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-light-bulb"></em> ti-light-bulb
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-info"></em> ti-info
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-infinite"></em> ti-infinite
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-id-badge"></em> ti-id-badge
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-hummer"></em> ti-hummer
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-home"></em> ti-home
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-help"></em> ti-help
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-headphone"></em> ti-headphone
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-harddrives"></em> ti-harddrives
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-harddrive"></em> ti-harddrive
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-gift"></em> ti-gift
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-game"></em> ti-game
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-filter"></em> ti-filter
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-files"></em> ti-files
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-file"></em> ti-file
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-zip"></em> ti-zip
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-folder"></em> ti-folder
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-envelope"></em> ti-envelope
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-dashboard"></em> ti-dashboard
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-cloud"></em> ti-cloud
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-cloud-up"></em> ti-cloud-up
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-cloud-down"></em> ti-cloud-down
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-clipboard"></em> ti-clipboard
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-calendar"></em> ti-calendar
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-book"></em> ti-book
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-bell"></em> ti-bell
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-basketball"></em> ti-basketball
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-bar-chart"></em> ti-bar-chart
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-bar-chart-alt"></em> ti-bar-chart-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-archive"></em> ti-archive
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-anchor"></em> ti-anchor
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-alert"></em> ti-alert
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-alarm-clock"></em> ti-alarm-clock
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-agenda"></em> ti-agenda
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-write"></em> ti-write
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-wallet"></em> ti-wallet
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-video-clapper"></em> ti-video-clapper
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-video-camera"></em> ti-video-camera
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-vector"></em> ti-vector
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-support"></em> ti-support
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-stamp"></em> ti-stamp
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-slice"></em> ti-slice
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-shortcode"></em> ti-shortcode
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-receipt"></em> ti-receipt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-pin2"></em> ti-pin2
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-pin-alt"></em> ti-pin-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-pencil-alt2"></em> ti-pencil-alt2
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-eraser"></em> ti-eraser
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-more"></em> ti-more
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-more-alt"></em> ti-more-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-microphone-alt"></em> ti-microphone-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-magnet"></em> ti-magnet
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-line-double"></em> ti-line-double
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-line-dotted"></em> ti-line-dotted
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-line-dashed"></em> ti-line-dashed
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-ink-pen"></em> ti-ink-pen
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-info-alt"></em> ti-info-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-help-alt"></em> ti-help-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-headphone-alt"></em> ti-headphone-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-gallery"></em> ti-gallery
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-face-smile"></em> ti-face-smile
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-face-sad"></em> ti-face-sad
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-credit-card"></em> ti-credit-card
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-comments-smiley"></em> ti-comments-smiley
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-time"></em> ti-time
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-share"></em> ti-share
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-share-alt"></em> ti-share-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-rocket"></em> ti-rocket
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-new-window"></em> ti-new-window
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-rss"></em> ti-rss
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-rss-alt"></em> ti-rss-alt
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>
        <b-card class="mb-4">
          <b-card-text>
            <h5 class="card-title">Control Icons</h5>
            <b-row class="icons">
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-control-stop"></em> ti-control-stop
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-control-shuffle"></em> ti-control-shuffle
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-control-play"></em> ti-control-play
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-control-pause"></em> ti-control-pause
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-control-forward"></em> ti-control-forward
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-control-backward"></em> ti-control-backward
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-volume"></em> ti-volume
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-control-skip-forward"></em>
                ti-control-skip-forward
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-control-skip-backward"></em>
                ti-control-skip-backward
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-control-record"></em> ti-control-record
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-control-eject"></em> ti-control-eject
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>
        <b-card class="mb-4">
          <b-card-text>
            <h5 class="card-title">Text Editor Icons</h5>
            <b-row class="icons">
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-paragraph"></em> ti-paragraph
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-uppercase"></em> ti-uppercase
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-underline"></em> ti-underline
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-text"></em> ti-text
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-Italic"></em> ti-Italic
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-smallcap"></em> ti-smallcap
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-list"></em> ti-list
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-list-ol"></em> ti-list-ol
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-align-right"></em> ti-align-right
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-align-left"></em> ti-align-left
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-align-justify"></em> ti-align-justify
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-align-center"></em> ti-align-center
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-quote-right"></em> ti-quote-right
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-quote-left"></em> ti-quote-left
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>
        <b-card class="mb-4">
          <b-card-text>
            <h5 class="card-title">Layout Icons</h5>
            <b-row class="icons">
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-width-full"></em> ti-layout-width-full
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-width-default"></em>
                ti-layout-width-default
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-width-default-alt"></em>
                ti-layout-width-default-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-tab"></em> ti-layout-tab
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-tab-window"></em> ti-layout-tab-window
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-tab-v"></em> ti-layout-tab-v
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-tab-min"></em> ti-layout-tab-min
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-slider"></em> ti-layout-slider
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-slider-alt"></em> ti-layout-slider-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-sidebar-right"></em>
                ti-layout-sidebar-right
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-sidebar-none"></em>
                ti-layout-sidebar-none
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-sidebar-left"></em>
                ti-layout-sidebar-left
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-placeholder"></em> ti-layout-placeholder
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-menu"></em> ti-layout-menu
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-menu-v"></em> ti-layout-menu-v
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-menu-separated"></em>
                ti-layout-menu-separated
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-menu-full"></em> ti-layout-menu-full
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-media-right"></em> ti-layout-media-right
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-media-right-alt"></em>
                ti-layout-media-right-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-media-overlay"></em>
                ti-layout-media-overlay
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-media-overlay-alt"></em>
                ti-layout-media-overlay-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-media-overlay-alt-2"></em>
                ti-layout-media-overlay-alt-2
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-media-left"></em> ti-layout-media-left
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-media-left-alt"></em>
                ti-layout-media-left-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-media-center"></em>
                ti-layout-media-center
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-media-center-alt"></em>
                ti-layout-media-center-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-list-thumb"></em> ti-layout-list-thumb
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-list-thumb-alt"></em>
                ti-layout-list-thumb-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-list-post"></em> ti-layout-list-post
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-list-large-image"></em>
                ti-layout-list-large-image
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-line-solid"></em> ti-layout-line-solid
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-grid4"></em> ti-layout-grid4
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-grid3"></em> ti-layout-grid3
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-grid2"></em> ti-layout-grid2
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-grid2-thumb"></em> ti-layout-grid2-thumb
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-cta-right"></em> ti-layout-cta-right
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-cta-left"></em> ti-layout-cta-left
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-cta-center"></em> ti-layout-cta-center
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-cta-btn-right"></em>
                ti-layout-cta-btn-right
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-cta-btn-left"></em>
                ti-layout-cta-btn-left
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-column4"></em> ti-layout-column4
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-column3"></em> ti-layout-column3
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-column2"></em> ti-layout-column2
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-accordion-separated"></em>
                ti-layout-accordion-separated
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-accordion-merged"></em>
                ti-layout-accordion-merged
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-accordion-list"></em>
                ti-layout-accordion-list
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-widgetized"></em> ti-widgetized
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-widget"></em> ti-widget
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-widget-alt"></em> ti-widget-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-view-list"></em> ti-view-list
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-view-list-alt"></em> ti-view-list-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-view-grid"></em> ti-view-grid
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-upload"></em> ti-upload
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-download"></em> ti-download
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-loop"></em> ti-loop
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-sidebar-2"></em> ti-layout-sidebar-2
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-grid4-alt"></em> ti-layout-grid4-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-grid3-alt"></em> ti-layout-grid3-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-grid2-alt"></em> ti-layout-grid2-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-column4-alt"></em> ti-layout-column4-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-column3-alt"></em> ti-layout-column3-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-layout-column2-alt"></em> ti-layout-column2-alt
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>
        <b-card class="mb-4">
          <b-card-text>
            <h5 class="card-title">Brand Icons</h5>
            <b-row class="icons">
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-flickr"></em> ti-flickr
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-flickr-alt"></em> ti-flickr-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-instagram"></em> ti-instagram
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-google"></em> ti-google
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-github"></em> ti-github
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-facebook"></em> ti-facebook
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-dropbox"></em> ti-dropbox
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-dropbox-alt"></em> ti-dropbox-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-dribbble"></em> ti-dribbble
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-apple"></em> ti-apple
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-android"></em> ti-android
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-yahoo"></em> ti-yahoo
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-trello"></em> ti-trello
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-stack-overflow"></em> ti-stack-overflow
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-soundcloud"></em> ti-soundcloud
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-sharethis"></em> ti-sharethis
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-sharethis-alt"></em> ti-sharethis-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-reddit"></em> ti-reddit
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-microsoft"></em> ti-microsoft
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-microsoft-alt"></em> ti-microsoft-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-linux"></em> ti-linux
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-jsfiddle"></em> ti-jsfiddle
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-joomla"></em> ti-joomla
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-html5"></em> ti-html5
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-css3"></em> ti-css3
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-drupal"></em> ti-drupal
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-wordpress"></em> ti-wordpress
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-tumblr"></em> ti-tumblr
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-tumblr-alt"></em> ti-tumblr-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-skype"></em> ti-skype
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-youtube"></em> ti-youtube
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-vimeo"></em> ti-vimeo
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-vimeo-alt"></em> ti-vimeo-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-twitter"></em> ti-twitter
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-twitter-alt"></em> ti-twitter-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-linkedin"></em> ti-linkedin
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-pinterest"></em> ti-pinterest
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-pinterest-alt"></em> ti-pinterest-alt
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-themify-logo"></em> ti-themify-logo
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-themify-favicon"></em> ti-themify-favicon
              </b-col>
              <b-col cols="12" sm="4" class="my-1">
                <em class="mr-2 ti-themify-favicon-alt"></em>
                ti-themify-favicon-alt
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "ThemifyIcons",
  data: () => ({
    page: {
      title: "Themify Icons",
    },
    breadcrumbs: [
      {
        text: "Icons",
        disabled: false,
        to: "#",
      },
      {
        text: "Themify Icons",
        disabled: true,
      },
    ],
  }),
};
</script>